// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__35UFM","socials":"Footer_socials__24ZBq","social_link":"Footer_social_link__27e7W","copyright":"Footer_copyright__2a65X"};